import React from 'react';
import { CountdownTimer } from './CountdownTimer';
import { ShieldCheckIcon, StarIcon, CheckCircleIcon, HeartIcon, ZapIcon, MoonIcon } from 'lucide-react';
export function SalesPage() {
  const handleCTA = () => {
    window.scrollTo({
      top: document.body.scrollHeight,
      behavior: 'smooth'
    });
  };
  return <div className="min-h-screen w-full" style={{
    backgroundColor: '#FDF8F3',
    color: '#1A1A1A'
  }} data-id="element-3">
      {/* ━━━ STICKY COUNTDOWN BANNER ━━━ */}
      <div className="sticky top-0 z-50 w-full py-3 px-4 flex flex-col sm:flex-row items-center justify-center gap-2 text-center" style={{
      backgroundColor: '#1A1A1A'
    }} data-id="element-4">
        <span className="text-white text-sm font-medium" data-id="element-5">
          ⚡️ <strong data-id="element-6">SPECIAL OFFER:</strong> Reset your cortisol levels for the
          price of a yoga class.
        </span>
        <span className="text-white text-sm flex items-center gap-2" data-id="element-7">
          <span style={{
          color: '#E8DDD0'
        }} data-id="element-8">
            Offer ends in:
          </span>
          <CountdownTimer data-id="element-9" />
        </span>
      </div>

      {/* ━━━ HERO SECTION ━━━ */}
      <section className="w-full px-4 pt-10 pb-8 md:pt-24 md:pb-16 text-center max-w-4xl mx-auto" data-id="element-10">
        <p className="text-xs font-bold uppercase tracking-widest mb-4" style={{
        color: '#4A7C59',
        fontFamily: 'system-ui, -apple-system, sans-serif'
      }} data-id="element-11">
          The Cortisol Cure
        </p>

        <h1 className="text-3xl md:text-6xl font-bold leading-tight mb-4 md:mb-6" style={{
        fontFamily: 'Georgia, serif',
        color: '#1A1A1A'
      }} data-id="element-12">
          Stop "Pushing Through" The Burnout:{' '}
          <span style={{
          color: '#4A7C59'
        }} data-id="element-13">
            Reset Your Nervous System
          </span>{' '}
          and Melt "Cortisol Belly" in Just{' '}
          <span style={{
          color: '#C85A2A'
        }} data-id="element-14">
            10 Minutes a Day.
          </span>
        </h1>

        <p className="text-base md:text-xl leading-relaxed mb-6 md:mb-8 max-w-2xl mx-auto" style={{
        color: '#3D3D3D',
        fontFamily: 'system-ui, -apple-system, sans-serif'
      }} data-id="element-15">
          Without HIIT, Without Restrictive Diets, and Without Adding More
          Stress to Your Busy Mom Life.
        </p>

        <CTAButton data-id="element-16" />

        <p className="text-xs mt-4" style={{
        color: '#8A7A6E',
        fontFamily: 'system-ui, -apple-system, sans-serif'
      }} data-id="element-17">
          🔒 30-Day Money-Back Guarantee &nbsp;|&nbsp; One-Time Payment of
          $14.92
        </p>
      </section>

      {/* ━━━ DIVIDER ━━━ */}
      <Divider data-id="element-18" />

      {/* ━━━ SECTION 1: THE HOOK ━━━ */}
      <section className="w-full px-4 py-8 md:py-16 max-w-3xl mx-auto" data-id="element-19">
        <p className="text-xs font-bold uppercase tracking-widest mb-4 text-center" style={{
        color: '#4A7C59',
        fontFamily: 'system-ui, -apple-system, sans-serif'
      }} data-id="element-20">
          Does This Sound Like You?
        </p>
        <h2 className="text-2xl md:text-4xl font-bold text-center mb-6 md:mb-8" style={{
        fontFamily: 'Georgia, serif',
        color: '#1A1A1A'
      }} data-id="element-21">
          You're Doing Everything "Right"... and Still Feeling Worse.
        </h2>

        <div className="rounded-2xl p-5 md:p-10 mb-5 md:mb-8" style={{
        backgroundColor: '#FFFFFF',
        boxShadow: '0 4px 24px rgba(0,0,0,0.07)',
        border: '1px solid #E8DDD0'
      }} data-id="element-22">
          <p className="text-sm md:text-lg leading-relaxed mb-4 md:mb-5" style={{
          fontFamily: 'system-ui, -apple-system, sans-serif',
          color: '#3D3D3D'
        }} data-id="element-23">
            By 3:00 PM, you're running on fumes. You look in the mirror and
            don't recognize the woman looking back—inflamed, exhausted, and
            constantly on edge. You've tried the fasted coffee, the hour-long
            Pilates classes, and intermittent fasting... but nothing works.
          </p>
          <p className="text-sm md:text-lg leading-relaxed" style={{
          fontFamily: 'system-ui, -apple-system, sans-serif',
          color: '#3D3D3D'
        }} data-id="element-24">
            In fact, it feels like the harder you push, the more that stubborn
            belly fat clings to your body.
          </p>
        </div>

        <div className="rounded-2xl p-5 md:p-10 border-l-4" style={{
        backgroundColor: '#F5F0E8',
        borderLeftColor: '#4A7C59'
      }} data-id="element-25">
          <p className="text-xs md:text-sm font-bold uppercase tracking-wide mb-2 md:mb-3" style={{
          color: '#4A7C59',
          fontFamily: 'system-ui, -apple-system, sans-serif'
        }} data-id="element-26">
            Here is the truth the fitness industry is hiding from you:
          </p>
          <p className="text-sm md:text-lg leading-relaxed font-medium" style={{
          fontFamily: 'Georgia, serif',
          color: '#1A1A1A'
        }} data-id="element-27">
            You don't have a willpower problem. You have a biological survival
            problem. Your body thinks it's under constant attack, and its
            natural response is to protect you by storing fat and draining your
            energy.
          </p>
        </div>
      </section>

      {/* ━━━ DIVIDER ━━━ */}
      <Divider data-id="element-28" />

      {/* ━━━ SECTION 2: PAIN AGITATION ━━━ */}
      <section className="w-full px-4 py-8 md:py-16 max-w-3xl mx-auto" data-id="element-29">
        <p className="text-xs font-bold uppercase tracking-widest mb-4 text-center" style={{
        color: '#C85A2A',
        fontFamily: 'system-ui, -apple-system, sans-serif'
      }} data-id="element-30">
          The Cortisol Trap
        </p>
        <h2 className="text-2xl md:text-4xl font-bold text-center mb-6 md:mb-10" style={{
        fontFamily: 'Georgia, serif',
        color: '#1A1A1A'
      }} data-id="element-31">
          Does This Sound Familiar?
        </h2>

        <div className="space-y-3 md:space-y-4 mb-6 md:mb-10" data-id="element-32">
          <PainPoint icon="😴" text={'You wake up feeling like you were hit by a truck, even after "8 hours" of sleep.'} data-id="element-33" />
          <PainPoint icon="⚡" text={'You live in a constant state of "fight or flight," snapping at every noise the kids make.'} data-id="element-34" />
          <PainPoint icon="🫃" text="Your stomach feels bloated, hard, and has a mind of its own (the infamous Cortisol Belly)." data-id="element-35" />
          <PainPoint icon="💔" text="You feel like you're failing at work and at home because you simply DO NOT have the energy to show up." data-id="element-36" />
        </div>

        <div className="rounded-2xl p-5 md:p-8 text-center" style={{
        backgroundColor: '#1A1A1A',
        color: '#FDF8F3'
      }} data-id="element-37">
          <p className="text-base md:text-xl font-bold mb-2 md:mb-3" style={{
          fontFamily: 'Georgia, serif'
        }} data-id="element-38">
            You are trapped in the Cortisol Death Loop.
          </p>
          <p className="text-xs md:text-base leading-relaxed" style={{
          fontFamily: 'system-ui, -apple-system, sans-serif',
          color: '#C8B8A8'
        }} data-id="element-39">
            You try intense exercise to lose weight → which spikes more cortisol
            → causes more inflammation → leaves you depleted → triggers sugar
            cravings → and the cycle starts all over again.
          </p>
          <p className="text-sm md:text-base font-bold" style={{
          fontFamily: 'Georgia, serif',
          color: '#4A7C59'
        }} data-id="element-40">
            It's time to break the loop.
          </p>
        </div>
      </section>

      {/* ━━━ DIVIDER ━━━ */}
      <Divider data-id="element-41" />

      {/* ━━━ SECTION 3: THE REVELATION ━━━ */}
      <section className="w-full px-4 py-8 md:py-16 max-w-3xl mx-auto text-center" data-id="element-42">
        <p className="text-xs font-bold uppercase tracking-widest mb-4" style={{
        color: '#4A7C59',
        fontFamily: 'system-ui, -apple-system, sans-serif'
      }} data-id="element-43">
          Introducing
        </p>
        <h2 className="text-2xl md:text-5xl font-bold mb-3 md:mb-4" style={{
        fontFamily: 'Georgia, serif',
        color: '#1A1A1A'
      }} data-id="element-44">
          THE CORTISOL CURE
        </h2>
        <p className="text-sm md:text-lg mb-5 md:mb-8" style={{
        color: '#4A7C59',
        fontFamily: 'system-ui, -apple-system, sans-serif',
        fontWeight: 600
      }} data-id="element-45">
          A Nervous System Regulation Protocol — Not Just Another Workout Plan
        </p>

        <div className="rounded-2xl p-5 md:p-10 mb-5 md:mb-8 text-left" style={{
        backgroundColor: '#FFFFFF',
        boxShadow: '0 4px 24px rgba(0,0,0,0.07)',
        border: '1px solid #E8DDD0'
      }} data-id="element-46">
          <p className="text-sm md:text-lg leading-relaxed mb-4 md:mb-5" style={{
          fontFamily: 'system-ui, -apple-system, sans-serif',
          color: '#3D3D3D'
        }} data-id="element-47">
            We discovered that by using{' '}
            <strong data-id="element-48">low-impact somatic movements</strong> (shaking, tapping, and
            psoas release), we can "trick" your brain into switching from{' '}
            <strong data-id="element-49">Survival Mode</strong> to <strong data-id="element-50">Repair Mode</strong>.
          </p>
          <p className="text-sm md:text-lg leading-relaxed" style={{
          fontFamily: 'system-ui, -apple-system, sans-serif',
          color: '#3D3D3D'
        }} data-id="element-51">
            When your nervous system finally feels safe, your metabolism ignites
            for the first time in years. The belly fat begins to mobilize
            because your body no longer feels the need to "protect" you with an
            extra layer of stress-fat.
          </p>
        </div>

        <div className="grid grid-cols-3 gap-2 md:gap-4 mb-5 md:mb-8" data-id="element-52">
          <FeaturePill icon={<ZapIcon className="w-5 h-5" data-id="element-54" />} text="10 Minutes a Day" data-id="element-53" />
          <FeaturePill icon={<HeartIcon className="w-5 h-5" data-id="element-56" />} text="Low-Impact Somatic Flows" data-id="element-55" />
          <FeaturePill icon={<MoonIcon className="w-5 h-5" data-id="element-58" />} text="Do It in Your PJs" data-id="element-57" />
        </div>

        <CTAButton data-id="element-59" />
      </section>

      {/* ━━━ DIVIDER ━━━ */}
      <Divider data-id="element-60" />

      {/* ━━━ SECTION 4: SOCIAL PROOF ━━━ */}
      <section className="w-full px-4 py-8 md:py-16 max-w-4xl mx-auto" data-id="element-61">
        <p className="text-xs font-bold uppercase tracking-widest mb-4 text-center" style={{
        color: '#4A7C59',
        fontFamily: 'system-ui, -apple-system, sans-serif'
      }} data-id="element-62">
          Real Women. Real Results.
        </p>
        <h2 className="text-2xl md:text-4xl font-bold text-center mb-6 md:mb-10" style={{
        fontFamily: 'Georgia, serif',
        color: '#1A1A1A'
      }} data-id="element-63">
          What Happens When You Stop Fighting Your Body
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-64">
          <TestimonialCard quote="I lost 4 inches off my waist in 21 days without stepping foot in a gym. I finally have energy to play with my kids after work. This literally saved my sanity." name="Jennifer S." detail="39, Texas" stars={5} data-id="element-65" />
          <TestimonialCard quote="I thought I needed more caffeine. Turns out I just needed to regulate my vagus nerve. The 10-minute somatic flows are now a non-negotiable part of my morning." name="Michelle R." detail="42, Florida" stars={5} data-id="element-66" />
        </div>
      </section>

      {/* ━━━ DIVIDER ━━━ */}
      <Divider data-id="element-67" />

      {/* ━━━ SECTION 5: VALUE STACK / OFFER ━━━ */}
      <section id="offer" className="w-full px-4 py-8 md:py-16 max-w-3xl mx-auto" data-id="element-68">
        <p className="text-xs font-bold uppercase tracking-widest mb-4 text-center" style={{
        color: '#C85A2A',
        fontFamily: 'system-ui, -apple-system, sans-serif'
      }} data-id="element-69">
          Everything You Get Today
        </p>
        <h2 className="text-2xl md:text-4xl font-bold text-center mb-6 md:mb-10" style={{
        fontFamily: 'Georgia, serif',
        color: '#1A1A1A'
      }} data-id="element-70">
          The Cortisol Cure Complete Bundle
        </h2>

        <div className="rounded-2xl overflow-hidden mb-8" style={{
        border: '2px solid #4A7C59',
        boxShadow: '0 8px 32px rgba(74,124,89,0.15)'
      }} data-id="element-71">
          {/* Main product */}
          <div className="p-5 md:p-8" style={{
          backgroundColor: '#4A7C59'
        }} data-id="element-72">
            <div className="flex items-start justify-between gap-4" data-id="element-73">
              <div data-id="element-74">
                <p className="text-xs font-bold uppercase tracking-widest text-green-200 mb-1" data-id="element-75">
                  Core Program
                </p>
                <h3 className="text-lg md:text-2xl font-bold text-white" style={{
                fontFamily: 'Georgia, serif'
              }} data-id="element-76">
                  📗 The Cortisol Cure Core Ebook
                </h3>
                <p className="text-green-100 text-sm mt-1" style={{
                fontFamily: 'system-ui, -apple-system, sans-serif'
              }} data-id="element-77">
                  The step-by-step 21-day system
                </p>
              </div>
              <div className="text-right flex-shrink-0" data-id="element-78">
                <p className="text-green-200 text-xs line-through" data-id="element-79">$197</p>
                <p className="text-white font-bold text-lg" data-id="element-80">Included</p>
              </div>
            </div>
          </div>

          {/* Bonuses */}
          <div className="divide-y" style={{
          backgroundColor: '#FFFFFF',
          borderColor: '#E8DDD0'
        }} data-id="element-81">
            <BonusRow number="1" title='7-Day Anti-Inflammatory "No-Cook" Meal Plan' value="$97" data-id="element-82" />
            <BonusRow number="2" title='5-Minute "Emergency Calm" Audio Series' value="$67" data-id="element-83" />
          </div>

          {/* Total */}
          <div className="p-5 md:p-8" style={{
          backgroundColor: '#F5F0E8'
        }} data-id="element-84">
            <div className="flex items-center justify-between mb-2" data-id="element-85">
              <span className="text-base font-medium" style={{
              color: '#6B5B4E',
              fontFamily: 'system-ui, -apple-system, sans-serif'
            }} data-id="element-86">
                Total Value:
              </span>
              <span className="text-xl font-bold line-through" style={{
              color: '#9A8A7E',
              fontFamily: 'Georgia, serif'
            }} data-id="element-87">
                $361
              </span>
            </div>
            <div className="flex items-center justify-between" data-id="element-88">
              <span className="text-lg font-bold" style={{
              color: '#1A1A1A',
              fontFamily: 'system-ui, -apple-system, sans-serif'
            }} data-id="element-89">
                Today's Price:
              </span>
              <div className="text-right" data-id="element-90">
                <span className="text-4xl font-bold" style={{
                color: '#C85A2A',
                fontFamily: 'Georgia, serif'
              }} data-id="element-91">
                  $14.27
                </span>
                <span className="text-sm ml-1" style={{
                color: '#6B5B4E'
              }} data-id="element-92">
                  USD
                </span>
              </div>
            </div>
            <p className="text-xs text-center mt-2" style={{
            color: '#8A7A6E',
            fontFamily: 'system-ui, -apple-system, sans-serif'
          }} data-id="element-93">
              One-time payment. No subscriptions. No hidden fees.
            </p>
          </div>
        </div>

        <CTAButton large data-id="element-94" />
        <p className="text-xs text-center mt-4" style={{
        color: '#8A7A6E',
        fontFamily: 'system-ui, -apple-system, sans-serif'
      }} data-id="element-95">
          🔒 Secure checkout &nbsp;|&nbsp; Instant digital access &nbsp;|&nbsp;
          30-Day Money-Back Guarantee
        </p>
      </section>

      {/* ━━━ DIVIDER ━━━ */}
      <Divider data-id="element-96" />

      {/* ━━━ SECTION 6: GUARANTEE ━━━ */}
      <section className="w-full px-4 py-8 md:py-16 max-w-3xl mx-auto" data-id="element-97">
        <div className="rounded-2xl p-6 md:p-10 text-center" style={{
        backgroundColor: '#FFFFFF',
        border: '2px solid #D4A843',
        boxShadow: '0 4px 24px rgba(212,168,67,0.15)'
      }} data-id="element-98">
          <div className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6" style={{
          backgroundColor: '#FDF3DC'
        }} data-id="element-99">
            <ShieldCheckIcon className="w-8 h-8" style={{
            color: '#D4A843'
          }} data-id="element-100" />
          </div>
          <p className="text-xs font-bold uppercase tracking-widest mb-3" style={{
          color: '#D4A843',
          fontFamily: 'system-ui, -apple-system, sans-serif'
        }} data-id="element-101">
            Our Iron-Clad Promise
          </p>
          <h2 className="text-xl md:text-3xl font-bold mb-3 md:mb-4" style={{
          fontFamily: 'Georgia, serif',
          color: '#1A1A1A'
        }} data-id="element-102">
            The "Feel Lighter" 30-Day Money Back Guarantee
          </h2>
          <p className="text-sm md:text-lg leading-relaxed mb-3 md:mb-4" style={{
          fontFamily: 'system-ui, -apple-system, sans-serif',
          color: '#3D3D3D'
        }} data-id="element-103">
            Try it for 30 days. If you don't feel your inflammation go down, if
            you don't have more energy, and if you don't sleep better than you
            have in years, simply send us an email and we will refund every
            penny.
          </p>
          <p className="text-sm md:text-base font-bold" style={{
          fontFamily: 'Georgia, serif',
          color: '#4A7C59'
        }} data-id="element-104">
            No questions asked. Every cent of the risk is on us.
          </p>
        </div>
      </section>

      {/* ━━━ FINAL CTA ━━━ */}
      <section className="w-full px-4 py-10 md:py-20 text-center" style={{
      backgroundColor: '#1A1A1A'
    }} data-id="element-105">
        <p className="text-xs font-bold uppercase tracking-widest mb-4" style={{
        color: '#D4A843',
        fontFamily: 'system-ui, -apple-system, sans-serif'
      }} data-id="element-106">
          Your Body Is Ready to Heal
        </p>
        <h2 className="text-2xl md:text-5xl font-bold mb-4 md:mb-6 max-w-2xl mx-auto" style={{
        fontFamily: 'Georgia, serif',
        color: '#FDF8F3'
      }} data-id="element-107">
          You Deserve to Feel Like Yourself Again.
        </h2>
        <p className="text-sm md:text-lg mb-5 md:mb-8 max-w-xl mx-auto" style={{
        fontFamily: 'system-ui, -apple-system, sans-serif',
        color: '#C8B8A8'
      }} data-id="element-108">
          Join thousands of moms who stopped fighting their bodies and started
          working with them.
        </p>
        <CTAButton large dark data-id="element-109" />
        <p className="text-xs mt-4" style={{
        color: '#6B5B4E',
        fontFamily: 'system-ui, -apple-system, sans-serif'
      }} data-id="element-110">
          🔒 30-Day Money-Back Guarantee &nbsp;|&nbsp; One-Time Payment of
          $14.27 &nbsp;|&nbsp; Instant Access
        </p>
      </section>

      {/* ━━━ FOOTER ━━━ */}
      <footer className="w-full px-4 py-6 text-center" style={{
      backgroundColor: '#111111',
      borderTop: '1px solid #2A2A2A'
    }} data-id="element-111">
        <p className="text-xs" style={{
        color: '#555555',
        fontFamily: 'system-ui, -apple-system, sans-serif'
      }} data-id="element-112">
          © 2025 The Cortisol Cure. All rights reserved. &nbsp;|&nbsp; Results
          may vary. This product is not intended to diagnose, treat, cure, or
          prevent any disease.
        </p>
      </footer>
    </div>;
}
/* ━━━ SUB-COMPONENTS ━━━ */
function CTAButton({
  large = false,
  dark = false
}: {
  large?: boolean;
  dark?: boolean;
}) {
  return <button className={`
        inline-block w-full max-w-xl font-bold uppercase tracking-wide rounded-xl
        transition-all duration-200 active:scale-95 cursor-pointer
        ${large ? 'px-8 py-5 text-base md:text-lg' : 'px-6 py-4 text-sm md:text-base'}
      `} style={{
    backgroundColor: '#C85A2A',
    color: '#FFFFFF',
    fontFamily: 'system-ui, -apple-system, sans-serif',
    boxShadow: '0 4px 20px rgba(200,90,42,0.4)',
    letterSpacing: '0.03em'
  }} onClick={() => {
    document.getElementById('offer')?.scrollIntoView({
      behavior: 'smooth'
    });
  }} onMouseEnter={e => {
    ;
    (e.currentTarget as HTMLButtonElement).style.backgroundColor = '#A84820';
  }} onMouseLeave={e => {
    ;
    (e.currentTarget as HTMLButtonElement).style.backgroundColor = '#C85A2A';
  }} data-id="element-113">
      👉 YES! I WANT TO RESET MY CORTISOL & MELT THE BELLY FAT — START FOR
      $14.27
    </button>;
}
function Divider() {
  return <div className="w-full max-w-3xl mx-auto px-4" data-id="element-114">
      <div className="h-px w-full" style={{
      backgroundColor: '#E8DDD0'
    }} data-id="element-115" />
    </div>;
}
function PainPoint({
  icon,
  text
}: {
  icon: string;
  text: string;
}) {
  return <div className="flex items-start gap-4 rounded-xl p-4 md:p-5" style={{
    backgroundColor: '#FFFFFF',
    border: '1px solid #E8DDD0',
    boxShadow: '0 2px 8px rgba(0,0,0,0.04)'
  }} data-id="element-116">
      <span className="text-2xl flex-shrink-0 mt-0.5" data-id="element-117">{icon}</span>
      <p className="text-base leading-relaxed" style={{
      fontFamily: 'system-ui, -apple-system, sans-serif',
      color: '#3D3D3D'
    }} data-id="element-118">
        {text}
      </p>
    </div>;
}
function FeaturePill({
  icon,
  text
}: {
  icon: React.ReactNode;
  text: string;
}) {
  return <div className="flex flex-col sm:flex-row items-center justify-center gap-1 sm:gap-2 rounded-full px-2 py-2 md:px-4 md:py-3 text-center" style={{
    backgroundColor: '#EDF4F0',
    color: '#4A7C59'
  }} data-id="element-119">
      {icon}
      <span className="text-xs md:text-sm font-semibold leading-tight" style={{
      fontFamily: 'system-ui, -apple-system, sans-serif'
    }} data-id="element-120">
        {text}
      </span>
    </div>;
}
function TestimonialCard({
  quote,
  name,
  detail,
  stars
}: {
  quote: string;
  name: string;
  detail: string;
  stars: number;
}) {
  return <div className="rounded-2xl p-6 md:p-8 flex flex-col" style={{
    backgroundColor: '#FFFFFF',
    border: '1px solid #E8DDD0',
    boxShadow: '0 4px 16px rgba(0,0,0,0.06)'
  }} data-id="element-121">
      <div className="flex gap-1 mb-4" data-id="element-122">
        {Array.from({
        length: stars
      }).map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-current" style={{
        color: '#D4A843'
      }} data-id="element-123" />)}
      </div>
      <p className="text-base md:text-lg leading-relaxed mb-6 flex-1 italic" style={{
      fontFamily: 'Georgia, serif',
      color: '#2D2D2D'
    }} data-id="element-124">
        "{quote}"
      </p>
      <div className="flex items-center gap-3" data-id="element-125">
        <div className="w-10 h-10 rounded-full flex items-center justify-center font-bold text-white text-sm flex-shrink-0" style={{
        backgroundColor: '#4A7C59',
        fontFamily: 'system-ui, -apple-system, sans-serif'
      }} data-id="element-126">
          {name.charAt(0)}
        </div>
        <div data-id="element-127">
          <p className="font-bold text-sm" style={{
          color: '#1A1A1A',
          fontFamily: 'system-ui, -apple-system, sans-serif'
        }} data-id="element-128">
            {name}
          </p>
          <p className="text-xs" style={{
          color: '#8A7A6E',
          fontFamily: 'system-ui, -apple-system, sans-serif'
        }} data-id="element-129">
            {detail}
          </p>
        </div>
      </div>
    </div>;
}
function BonusRow({
  number,
  title,
  value
}: {
  number: string;
  title: string;
  value: string;
}) {
  return <div className="flex items-center gap-4 p-4 md:p-5" data-id="element-130">
      <div className="w-8 h-8 rounded-full flex items-center justify-center text-xs font-bold flex-shrink-0" style={{
      backgroundColor: '#EDF4F0',
      color: '#4A7C59',
      fontFamily: 'system-ui, -apple-system, sans-serif'
    }} data-id="element-131">
        {number}
      </div>
      <div className="flex-1" data-id="element-132">
        <p className="text-sm font-medium" style={{
        color: '#1A1A1A',
        fontFamily: 'system-ui, -apple-system, sans-serif'
      }} data-id="element-133">
          <span className="font-bold" style={{
          color: '#4A7C59'
        }} data-id="element-134">
            Bonus #{number}:
          </span>{' '}
          {title}
        </p>
      </div>
      <div className="text-right flex-shrink-0" data-id="element-135">
        <p className="text-xs line-through" style={{
        color: '#9A8A7E',
        fontFamily: 'system-ui, -apple-system, sans-serif'
      }} data-id="element-136">
          {value}
        </p>
        <p className="text-xs font-bold" style={{
        color: '#4A7C59',
        fontFamily: 'system-ui, -apple-system, sans-serif'
      }} data-id="element-137">
          FREE
        </p>
      </div>
    </div>;
}